import {
  CHANGE_MAIN_DATA_CHILD,
  BLUR_MAIN_DATA_CHILD,
  SUBMIT_MAIN_DATA_CHILD
} from '../constants';

export const changeMainDataChild = payload => ({
  type: CHANGE_MAIN_DATA_CHILD,
  payload
});
export const blurMainDataChild = payload => ({
  type: BLUR_MAIN_DATA_CHILD,
  payload
});
export const submitMainDataChild = payload => ({
  type: SUBMIT_MAIN_DATA_CHILD,
  payload
});
